import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import partial from 'lodash/partial';
import { fetch, clear } from 'your_projects/ducks';
import Gallery from 'your_projects/components/gallery';

const mapStateToProps = ({ user, yourProjects }) => {
  const { isFetching, list } = yourProjects;

  return {
    user: user.profile_data,
    projects: list,
    isFetching
  };
}

const mapDispatchToProps = (dispatch, { userType, projectType, location }) => {
  return bindActionCreators({
    fetch: partial(fetch, userType, projectType, location.query),
    clear
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Gallery));



// WEBPACK FOOTER //
// ./your_projects/containers/gallery.js